import type { Template } from "@/types";

export const PO_04_H3_V1: Template[] = [
{
    id: "po-04-h3v1-01",
    name: "PO 01 - H3V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h3_v1_01.png",
    size: [1136, 854],
    style: {},
        slots: [
            { id: "1", x: 87, y: 93, width: 395, height: 668, rotation: 0, imageRotation: 0 },
            { id: "2", x: 726, y: 0, width: 357, height: 280, rotation: 0, imageRotation: 0 },
            { id: "3", x: 726, y: 288, width: 357, height: 279, rotation: 0, imageRotation: 0 },
            { id: "4", x: 726, y: 575, width: 357, height: 279, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-04-h3v1-02",
    name: "PO 02 - H3V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h3_v1_02.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 51, y: 61, width: 434, height: 733, rotation: 0, imageRotation: 0 },
        { id: "2", x: 763, y: 61, width: 322, height: 239, rotation: 0, imageRotation: 0 },
        { id: "3", x: 763, y: 308, width: 322, height: 239, rotation: 0, imageRotation: 0 },
        { id: "4", x: 763, y: 555, width: 322, height: 239, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h3v1-03",
    name: "PO 03 - H3V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h3_v1_03.png",
    size: [1136, 854],
    style: {},
    slots: [       
        { id: "1", x: 107, y: 61, width: 322, height: 239, rotation: 0, imageRotation: 0 },
        { id: "2", x: 107, y: 308, width: 322, height: 239, rotation: 0, imageRotation: 0 },
        { id: "3", x: 107, y: 555, width: 322, height: 239, rotation: 0, imageRotation: 0 },
        { id: "4", x: 634, y: 61, width: 434, height: 733, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h3v1-04",
    name: "PO 04 - H3V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h3_v1_04.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 73, y: 192, width: 422, height: 299, rotation: 0, imageRotation: 0 },       
        { id: "2", x: 73, y: 499, width: 207, height: 164, rotation: 0, imageRotation: 0 },
        { id: "3", x: 288, y: 499, width: 207, height: 164, rotation: 0, imageRotation: 0 },
        { id: "4", x: 634, y: 61, width: 434, height: 733, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h3v1-05",
    name: "PO 05 - H3V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h3_v1_05.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 73, y: 364, width: 422, height: 299, rotation: 0, imageRotation: 0 },      
        { id: "2", x: 73, y: 192, width: 207, height: 164, rotation: 0, imageRotation: 0 },
        { id: "3", x: 288, y: 192, width: 207, height: 164, rotation: 0, imageRotation: 0 },
        { id: "4", x: 712, y: 192, width: 279, height: 471, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h3v1-06",
    name: "PO 06 - H3V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h3_v1_06.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 47, y: 174, width: 474, height: 335, rotation: 0, imageRotation: 0 },       
        { id: "2", x: 47, y: 517, width: 233, height: 179, rotation: 0, imageRotation: 0 },
        { id: "3", x: 288, y: 517, width: 233, height: 179, rotation: 0, imageRotation: 0 },
        { id: "4", x: 568, y: 0, width: 568, height: 854, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h3v1-07",
    name: "PO 07 - H3V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h3_v1_07.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 67, y: 61, width: 434, height: 733, rotation: 0, imageRotation: 0 },
        { id: "2", x: 641, y: 363, width: 422, height: 299, rotation: 0, imageRotation: 0 },
        { id: "3", x: 641, y: 191, width: 207, height: 164, rotation: 0, imageRotation: 0 },
        { id: "4", x: 856, y: 191, width: 207, height: 164, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h3v1-08",
    name: "PO 08 - H3V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h3_v1_08.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 182, width: 277, height: 241, rotation: 0, imageRotation: 0 },
        { id: "2", x: 0, y: 431, width: 277, height: 241, rotation: 0, imageRotation: 0 },
        { id: "3", x: 285, y: 182, width: 564, height: 489, rotation: 0, imageRotation: 0 },
        { id: "4", x: 857, y: 182, width: 279, height: 489, rotation: 0, imageRotation: 0 }      
    ],
},

{
    id: "po-04-h3v1-09",
    name: "PO 09 - H3V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h3_v1_09.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 47, y: 59, width: 411, height: 737, rotation: 0, imageRotation: 0 },
        { id: "2", x: 466, y: 59, width: 623, height: 501, rotation: 0, imageRotation: 0 },
        { id: "3", x: 466, y: 568, width: 308, height: 228, rotation: 0, imageRotation: 0 },
        { id: "4", x: 782, y: 568, width: 307, height: 228, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h3v1-10",
    name: "PO 10 - H3V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h3_v1_10.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 174, y: 80, width: 244, height: 392, rotation: 0, imageRotation: 0 },
        { id: "2", x: 426, y: 80, width: 536, height: 392, rotation: 0, imageRotation: 0 },
        { id: "3", x: 174, y: 480, width: 390, height: 296, rotation: 0, imageRotation: 0 },
        { id: "4", x: 572, y: 480, width: 390, height: 296, rotation: 0, imageRotation: 0 }
    ],
}
];